export { default } from './quick-view-drawer';
